export class GdsgWorkerHeartbeats {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "consolidation",
            "baseName": "consolidation",
            "type": "GdsgWorkerHeartbeatStats",
            "format": ""
        },
        {
            "name": "replication",
            "baseName": "replication",
            "type": "GdsgWorkerHeartbeatStats",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GdsgWorkerHeartbeats.attributeTypeMap;
    }
    constructor() {
    }
}
